import { useField } from 'formik';

function TextareaField(props) {
    const [field, meta] = useField(props);

    return (
        <div>
            <textarea {...field} {...props}></textarea>
            {meta.touched && meta.error && (
                <p className="mt-4 text-xs font-bold text-red">{JSON.stringify(meta.error)}</p>
            )}
        </div>
    );
}

export default TextareaField;
